<mf-page title="Editar empresa">
  @if (companyDto) {
  <mf-company
    [companyDto]="companyDto"
    (save)="save($event)" />
  }
</mf-page>
